import { v4 as uuidv4 } from 'uuid';
import eventBus from "@/event/event";
// import { showAlert } from "@/pages/Home";

function paramsToUrl(params) {
    let _url = ''
    for (const param in params) {
        _url += `${param}=${encodeURI(params[param])}&`
    }
    if (_url.length > 0) {
        return '?' + _url.substring(0, _url.lastIndexOf('&'))
    } else {
        return ''
    }
}

const devBaseUrl = 'https://ps-sd-dev.cemeta.cn' 
const proBaseUrl = 'https://ps-sd.cemeta.cn'

let uuid = window.localStorage.getItem('uuid');
if (!uuid) {
    uuid = uuidv4();
    window.localStorage.setItem('uuid', uuid);
}

export function http({
    baseUrl = proBaseUrl,
    url,
    method,
    query = {},
    body,
    headers = {},
}) {
    let _url = baseUrl + url + paramsToUrl(query)
    let timer = null

    return new Promise((resolve, reject) => {
        const _headers = { ...headers, 'x-device-id': uuid }
        let user = localStorage.getItem('userInfo')
        if (user) {
            user = JSON.parse(user)
            _headers['x-token'] = user.token
        }
        const fetchPromise = fetch(_url, {
            method,
            body: body && JSON.stringify(body),
            headers: {
                Accept: 'application/json',
                'Content-type': 'application/json',
                ..._headers,
            },
        })
            .then((res) => {
                if (!res || res?._contentType === "text/plain") {
                    throw new Error('服务器接口异常！')
                } else {
                    return res?.json()
                }
            })
            .then((res) => {
                const arrayList = [
                ]

                if (arrayList.includes(url)) {
                    return res
                } else {
                    // reject(123)
                    if (res.status === 'ok') {
                        return res.data
                    } else {
                        reject(res?.err_msg || '服务异常！');
                        // alert && showAlert(res?.err_msg || '服务异常！');
                        if (res?.err_msg === '该账号已在其他设备登录' || res?.err_msg === '未登录') {
                            eventBus.emit('logout')
                        }
                        // reject(null)
                    }
                }
            })
            .catch((err) => {
                reject(err?.err_msg || err?.message || '网络异常！');
                // alert && showAlert(err?.err_msg || '网络异常！');
                // reject(null)
            })

        const specialTimeoutPromise = new Promise((_, rej) => {
            clearTimeout(timer)
            timer = setTimeout(() => {
                rej({name: 'timeout'})
            }, 300000)
        });

        const almostTimeoutPromise = new Promise((_, rej) => {
            clearTimeout(timer)
            timer = setTimeout(() => {
                rej({name: 'timeout'})
            }, 60000)
        });
        
        const arrayList = [
        ]

        const timeoutPromise = arrayList.includes(url) ? specialTimeoutPromise : almostTimeoutPromise 
        Promise.race([fetchPromise, timeoutPromise])
            .then(resolve)
            .catch(reject);
    })
}
